import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDGY-8_ENO-TBqJ0apW-HmUkvWU3vNof_M",
  authDomain: "madfilms-com.firebaseapp.com",
  projectId: "madfilms-com",
  storageBucket: "madfilms-com.appspot.com",
  messagingSenderId: "500799318804",
  appId: "1:500799318804:web:b0790b05e75bf0e77ef001",
  measurementId: "G-D433RKY2H0",
};
export const app = initializeApp(firebaseConfig);
